
import ajax from './_ajax';

const api = {};
api.getAllQualificationCertificates = function () {
  return ajax.get('/api/QualificationCertificate/GetAllQualificationCertificates');
};
export default api;



// WEBPACK FOOTER //
// ./src/api/qualificationCertificateApi.js